import Tooltip from 'components/tooltip/Tooltip';
import { PropertySeasonalRule } from 'models/seasonality/SeasonalCancellationPolicy';
import SeasonalRuleTooltip from './SeasonalRuleTooltip';
import { SeasonalRuleViewContainer } from './SeasonalRuleView.styles';

const SeasonalRuleView = ({
  rule,
  propertyUid,
  leftPx,
  widthPx,
}: {
  rule: PropertySeasonalRule;
  propertyUid: string;
  leftPx: number;
  widthPx: number;
}) => (
  <Tooltip
    id={`seasonal-rule-${propertyUid}-${rule.ruleUid}`}
    text={<SeasonalRuleTooltip rule={rule} />}
    placement="top"
  >
    <SeasonalRuleViewContainer
      $leftPx={leftPx}
      $widthPx={widthPx}
      $color={rule.color}
      data-testid={`seasonal-rule-view-${propertyUid}-${rule.ruleUid}`}
      data-seasonal-rule-uid={rule.ruleUid}
    >
      {rule.ruleName}
    </SeasonalRuleViewContainer>
  </Tooltip>
);

export default SeasonalRuleView;
